const step_up = {
    verify_your_identity: '신원 확인',
    choose_method_description: '계속하려면 다음 방법 중 하나로 본인임을 확인하세요.',
    password: '비밀번호',
    password_description: '계정 비밀번호 입력',
    enter_password_description: '계속하려면 계정 비밀번호를 입력하세요.',
    enter_verification_code_description: '{{identifier}}(으)로 전송된 인증 코드를 입력하세요.',
    subject_proof_description: '계속하려면 내 계정에 연결된 계정을 통해 본인임을 확인하세요. 그런 다음 인증 방법을 설정할 수 있습니다.',
    subject_mismatch: '계정이 일치하지 않습니다',
    subject_mismatch_description: '사용한 계정은 내 계정에 연동되어 있지 않습니다. 연동된 계정을 사용하고, 필요하면 공급자에서 계정을 전환하세요.',
    no_method_available: '사용 가능한 인증 방법 없음',
    no_method_available_description: '이 계정에는 이 확인을 완료할 수 있는 방법이 없습니다. 도움이 필요하면 관리자에게 문의하세요.',
};
export default Object.freeze(step_up);
